var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoContainer",class:{ embedded: _vm.embed },staticStyle:{"position":"relative","width":"100%"}},[_c('video',{ref:"shakaVideo",attrs:{"poster":_vm.posterURL,"controls":"","autoplay":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }